import { SvgIcon, SvgIconProps } from '@mui/material';

const CheckmarkRoundIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" rx="12" fill="#64A338" />
      <path
        d="M8 11.7576L11.0588 14.6666L16.6667 9.33331"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);

export default CheckmarkRoundIcon;
